var validEmailAccessCodeExpirationTimeout = null;

/**
 * Sends a verification email via AJAX.
 * @param {string} email
 * @returns {Promise}
 */
function sendVerificationEmail(email) {
    return new Promise((resolve, reject) => {
        $.ajax({
            method: "POST",
            url: "/registration/SendVerificationEmail",
            data: JSON.stringify({ email }),
            contentType: "application/json",
        })
            .done(function (data) {
                if (data.success) {
                    resolve(data);
                } else {
                    reject(data.message || "Failed to send verification email.");
                }
            })
            .fail(function () {
                reject("Error sending verification email.");
            });
    });
}

/**
 * Verifies the email code via AJAX.
 * @param {string} email - The email address to verify.
 * @param {string} code - The verification code to check.
 * @returns {Promise} - Resolves with server response if successful, rejects with error message otherwise.
 */
function verifyEmailCode(email, code) {
    // Clear out the existing timeout for the code expiration.
    if (validEmailAccessCodeExpirationTimeout) {
        clearTimeout(validEmailAccessCodeExpirationTimeout);
    }

    var data = { Email: email, Code: code };
    return new Promise((resolve, reject) => {
        $.ajax({
            method: "POST",
            url: "/registration/verifyEmailCode",
            data: JSON.stringify(data),
            contentType: "application/json",
        })
            .done(function (data) {
                if (data.success) {
                    // Set the expiration timeout for the valid email access code.
                    resolve(data);

                    if (data.expiresAfterUtc != null) {
                        var newTimeoutInMS = new Date(data.expiresAfterUtc).getTime() - (new Date()).getTime();

                        if (newTimeoutInMS > 0) {
                            setTimeout(function () {
                                $('#EmailAddress').trigger('email-verification-expired');
                            }, newTimeoutInMS);
                        }
                    }
                } else {
                    reject(data);
                }
            })
            .fail(function () {
                reject("Error sending verification email.");
            });
    });
}

function resetEmailValidation() {
    $('#sendVerificationEmailBtnContainer').removeClass('d-none').addClass('d-flex');
    $('#verifyEmailCodeContainer').addClass('d-none').removeClass('d-flex');
    $("#EmailAddress-error").text("");
    $("#sendEmail-error").addClass('d-none').text("");
    $("#verificationCode-error").addClass("d-none").text("");
    $("#validatedCheckMark").addClass('d-none');
    $('#emailVerificationCodeInput').val('');
}

var emailExpiresAfterTimeout = null;

// Send verification email
$(document).on('click', '#sendVerificationEmailBtn, #sendNewEmailCodeBtn', function (e) {
    e.preventDefault();
    const email = $('#EmailAddress').val().trim();
    if (email) {
        $("#verificationCode-error").addClass("d-none");
        $("#EmailAddress-error").text("");
        sendVerificationEmail(email)
            .then(function (data) {
                if (emailExpiresAfterTimeout) {
                    clearTimeout(emailExpiresAfterTimeout);
                }

                var defaultTimeout = (15 * 60 * 1000); // 15 minutes.
                var timeoutMs = 0;

                if (data.expiresAfterUtc != null) {
                    $("#EmailValidationExpiresAfterUtc").val(data.expiresAfterUtc);
                    var expirationDate = new Date(data.expiresAfterUtc);
                    var now = new Date();
                    var differenceMS = expirationDate.getTime() - now.getTime();
                    if (differenceMS < 0) {
                        differenceMS = 1;
                    }
                    timeoutMs = differenceMS;
                } else {
                    timeoutMs = defaultTimeout;
                }

                emailExpiresAfterTimeout = setTimeout(function () {
                    emailExpiresAfterTimeout = null;
                    resetEmailValidation();
                    $("#sendEmail-error").removeClass('d-none').text("That code is expired. Please request a new code.");
                }, timeoutMs);

                // Hide the send button container
                $('#sendVerificationEmailBtnContainer').addClass('d-none').removeClass('d-flex');
                // Show the code input container
                $('#verifyEmailCodeContainer').removeClass('d-none').addClass('d-flex');
            })
            .catch(function (err) {
                $("#sendEmail-error").removeClass('d-none').text("An error occurred sending the verification email");
            });
    } else {
        $("#EmailAddress-error").text("Email is required");
    }
});

// Verify email code
$(document).on('click', '#verifyEmailCodeBtn', function () {
    let email = $('#EmailAddress').val().trim();
    const code = $('#emailVerificationCodeInput').val().trim();
    if (!code) {
        $("#verificationCode-error").removeClass("d-none").text("Please enter a code");
        return;
    }
    if (!email) {
        $("#EmailAddress-error").text("Email is required");
        return;
    }
    $("#verificationCode-error").addClass("d-none");
    verifyEmailCode(email, code)
        .then(function (data) {
            if (data.success) {
                $('#verifyEmailCodeContainer').addClass('d-none').removeClass('d-flex');
                $('#validatedCheckMark').removeClass("d-none");
                $('#verifyEmailCodeContainer').addClass('d-none');
                $('#EmailAddress').attr("data-validatedemail", email);

                // Clear out the field from serverValidationMessages["EmailAddress"],
                // then focus/unblur to remove the border.
                $('#EmailAddress').trigger('change');
                const $input = $("#EmailAddress");
                $input[0].focus();
                $input[0].blur();
            }
        })
        .catch(function (err) {
            $("#verificationCode-error").removeClass("d-none").text(err.message);
        });
});

$(document).on('change', '#EmailAddress', function () {
    let validatedEmail = $('#EmailAddress').attr("data-validatedemail");
    let inputEmail = $('#EmailAddress').val();
    if (validatedEmail && validatedEmail == inputEmail) {
        return;
    }
    resetEmailValidation();
});